import FJTextStyle from './FJTextStyle';
import FJGlitch from './style/FJGlitch';

class FJTextStyleGlitch extends FJTextStyle {
    initStyles(props = {}) {
        let glitch = new FJGlitch({
            ...props,
            offset: 30,
            angle: 160,
            color1: '#F9143D',
            color2: '#3CF5F7',
            position: 'relative',
        });
        this._styles = [glitch];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: [*, *], offset: *, width: *, direction: *}}
     */
    getAdjustInfo() {
        let glitch = this._styles[0];
        return {
            offset: glitch.offset,
            direction: glitch.angle,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        let glitch = this._styles[0];
        if (info.offset !== '') glitch.offset = info.offset;
        if (info.direction !== '') glitch.angle = info.direction;
    }
}

export default FJTextStyleGlitch;
